import type { ComponentType } from "react";
import { Navigate, Outlet, type RouteObject } from "react-router";
import { TownAccessProvider } from "./contexts/TownAccessContext";
import { LandingRoute } from "./routes/LandingRoute";
import { BrandedRouteFallback } from "./components/RouteFallback";
export { BrandedRouteFallback };

function AppProviders() {
  return (
    <TownAccessProvider>
      <Outlet />
    </TownAccessProvider>
  );
}

/** Loads a route and its providers together, so neither reaches the landing bundle. */
async function withRouteProviders(load: Promise<ComponentType>): Promise<{ Component: ComponentType }> {
  const [Route, { RouteProviders }] = await Promise.all([load, import("./routes/RouteProviders")]);
  return { Component: () => <RouteProviders><Route /></RouteProviders> };
}

export const appRoutes: RouteObject[] = [
  {
    Component: AppProviders,
    HydrateFallback: BrandedRouteFallback,
    children: [
      { index: true, Component: LandingRoute },
      ...["auth/email", "auth/forgot-password", "auth/reset-password", "auth/magic", "auth/verification", "auth/verify-email"].map(path => ({
        path,
        lazy: () => withRouteProviders(import("./routes/AuthRoute").then(route => route.AuthRoute)),
      })),
      { path: "join", lazy: () => withRouteProviders(import("./routes/JoinRoute").then(route => route.JoinRoute)) },
      { path: "town", lazy: () => withRouteProviders(Promise.all([import("./routes/TownRoute"), import("./routes/TownRouteProviders")])
        .then(([route, { TownRouteProviders }]) => () => <TownRouteProviders><route.TownRoute /></TownRouteProviders>)) },
      { path: "*", element: <Navigate replace to="/" /> },
    ],
  },
];
